(function() {
    angular
        .module("app")
        .controller("FooterController", FooterController)

    FooterController.$inject =[
        "$scope"
    ]

    function FooterController(
        $scope
    ){
        "use strict"

        /**
            $scope variables
         **/
        $scope.date = new Date()
    }
})()
